module.exports = __webpack_public_path__ + "img/MA.1dd4b2a1.svg";